/**
 * Utility functions for handling user permissions and menu access
 */

export interface Permission {
    id: number;
    permission_slug: string;
    permission_name: string;
    module_name?: string;
    // Add other permission properties as needed
}

/**
 * Extract menu name from permission slug
 * Example: "read_dashboard" -> "dashboard", "create_job_posting" -> "job_posting"
 */
export const extractMenuFromPermissionSlug = (permissionSlug: string): string => {
    if (!permissionSlug) return '';

    // Remove action prefixes (read_, create_, update_, delete_, manage_)
    const actionPrefixes = ['read_', 'create_', 'update_', 'delete_', 'manage_', 'view_', 'edit_'];

    let menuName = permissionSlug;
    for (const prefix of actionPrefixes) {
        if (permissionSlug.startsWith(prefix)) {
            menuName = permissionSlug.substring(prefix.length);
            break;
        }
    }

    return menuName;
};

/**
 * Extract action from permission slug
 * Example: "read_dashboard" -> "read", "create_job_posting" -> "create"
 */
export const extractActionFromPermissionSlug = (permissionSlug: string): string => {
    if (!permissionSlug) return '';

    const actionPrefixes = ['read', 'create', 'update', 'delete', 'manage', 'view', 'edit'];

    for (const action of actionPrefixes) {
        if (permissionSlug.startsWith(`${action}_`)) {
            return action;
        }
    }

    return permissionSlug;
};

/**
 * Check if user has permission for a specific menu and action
 */
// export const hasPermission = (
//   permissions: Permission[] | null,
//   menuName: string,
//   action: string = 'read'
// ): boolean => {
//   if (!permissions || !Array.isArray(permissions)) {
//     return false;
//   }

//   const permissionSlug = `${action}_${menuName}`;
//   return permissions.some(permission => 
//     permission.permission_slug === permissionSlug
//   );
// };

/**
 * Check if user has any permission for a specific module and action
 */
export const hasPermission = (
    permissions: Permission[] | null,
    menuName: string
): boolean => {
    if (!permissions || !Array.isArray(permissions)) {
        return false;
    }
    
    return permissions.some(item => {
        const slug = item?.permission_slug || "";
        return slug.includes(menuName); // example: menuName = "job_posting"
    });

    //   return permissions.some(permission => {
    //     const extractedMenu = extractMenuFromPermissionSlug(permission.permission_slug);
    //     return extractedMenu === menuName;
    //   });
};
